import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { GlobalsVariables } from '../global-Variables';

@Component({
  selector: 'app-vita',
  templateUrl: './vita.component.html',
  styleUrls: ['./vita.component.scss']
})
export class VitaComponent implements OnInit {

  constructor( public meta: Meta, public title: Title, private globalVari: GlobalsVariables ) {
    const site = 'vita';
    this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description });
    this.title.setTitle('Chris Wehrmann - ' + globalVari.meta[site].title );
  }


  ngOnInit() {
  }

}